export default __webpack_public_path__ + "static/media/global-footprint-Header-2k.532632fb.jpg";